var _excluded = ["children", "className", "showDrawer", "helpDrawerOpen", "icon"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import DrawerToggle from '../Drawer/DrawerToggle';
import classNames from 'classnames';
/**
 * A link that triggers the visibility of a help drawer
 */

export var HelpDrawerToggle = function HelpDrawerToggle(_ref) {
  var children = _ref.children,
    className = _ref.className,
    showDrawer = _ref.showDrawer,
    helpDrawerOpen = _ref.helpDrawerOpen,
    icon = _ref.icon,
    others = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(DrawerToggle, _extends({
    className: classNames(className, 'ds-c-help-drawer__toggle'),
    drawerOpen: helpDrawerOpen,
    showDrawer: showDrawer
  }, others), children, " ", icon);
};
export default HelpDrawerToggle;